import { t } from '@lingui/macro';

import MoreVert from '@material-ui/icons/MoreVert';
import CheckBoxOutlineBlank from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBox from '@material-ui/icons/CheckBox';

import useIsPrinting from '../../../utilities/PrintUtilities';
import { useOptions } from '../../page-framework/panel/Panel';
import { MenuAction, MenuActionItem } from '../../page-framework/actions/Actions';

function isShowTrendEnabled(options) {
    return options?.showStatusTrend !== false;
}

export default function MatrixDisplayOptionsAction() {
    const isPrinting = useIsPrinting();
    const [options, setOptions] = useOptions();
    const showStatusTrend = isShowTrendEnabled(options);

    function handleClick() {
        setOptions({ ...options, showStatusTrend: !showStatusTrend });
    }

    if (isPrinting) {
        return null;
    }

    return (
        <>
            <span className="matrixEditingActions">
                <MenuAction icon={<MoreVert />} tooltip={t`Customize the display options for this panel`}>
                    <MenuActionItem
                        icon={showStatusTrend ? <CheckBox /> : <CheckBoxOutlineBlank />}
                        label={t`Show status trend`}
                        onClick={handleClick}
                    />
                </MenuAction>
            </span>
        </>
    );
}

export function useStatusTrendVisibility() {
    const [options] = useOptions();
    return isShowTrendEnabled(options);
}
